import { type FeatureExpansionRequestType } from '@webapp/core/services/Marketo'
import { PRODUCT_TOUR_DEMO_IDS } from '../constants'

export const hasProductTour = (context: FeatureExpansionRequestType): boolean =>
  Boolean(PRODUCT_TOUR_DEMO_IDS[context])
